/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * (tsType: ModuleResponseWithRelations, schemaOptions: { includeRelations: true })
 */
export interface ModuleResponseWithRelations { 
    id: string;
    label: string;
    icon?: string;
    routerLink?: Array<string>;
    items?: Array<object>;
    url?: string;
    external?: boolean;
    isNew?: boolean;
}

